/* PT · Support page (spec-support-page-3c) — the header section assembles
   the tab row from every "PT · Support topic" section on the page, runs a
   one-open accordion across them, live search inside the active tab (with
   "also found in" pointers), task cards (open an answer / open the phone
   matcher / link), URL-hash deep links, and shows the phone matcher's
   result in place. Re-inits on Theme Editor section reloads. */
(function () {
  "use strict";
  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var booted = false, match = null;

  function cfgRead() {
    try { return JSON.parse((document.getElementById("pt-sp-data") || {}).textContent || "{}"); } catch (e) { return {}; }
  }

  function init() {
    var root = document.getElementById("pt-support");
    if (!root) return;
    document.documentElement.classList.add("pt-sp-js");
    var cfg = cfgRead();
    var HDR = Number(root.getAttribute("data-header-offset")) || Number(cfg.headerOffset) || 70;
    var panels = [].slice.call(document.querySelectorAll(".pt-sp-panel"));
    var tabsWrap = root.querySelector(".pt-sp-tabs");
    var q = root.querySelector("#pt-sp-q");
    if (!panels.length || !tabsWrap) return;

    /* ---- tabs, built from the topic sections in page order ---- */
    tabsWrap.innerHTML = "";
    var tabs = panels.map(function (p) {
      var slug = p.getAttribute("data-slug");
      var b = document.createElement("button");
      b.type = "button"; b.className = "pt-sp-tab"; b.setAttribute("role", "tab");
      b.id = "pt-sp-tab-" + slug; b.setAttribute("aria-controls", p.id); b.setAttribute("data-slug", slug);
      b.setAttribute("aria-selected", "false"); b.tabIndex = -1;
      b.textContent = p.getAttribute("data-label") || slug;
      tabsWrap.appendChild(b);
      return b;
    });
    var slugs = panels.map(function (p) { return p.getAttribute("data-slug"); });
    function panelOf(slug) { return panels.filter(function (p) { return p.getAttribute("data-slug") === slug; })[0] || null; }
    function activePanel() { return panels.filter(function (p) { return !p.hidden; })[0] || null; }

    function activate(slug, setHash) {
      if (slugs.indexOf(slug) < 0) return;
      tabs.forEach(function (t) {
        var on = t.getAttribute("data-slug") === slug;
        t.classList.toggle("pt-on", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p) { var on = p.getAttribute("data-slug") === slug; p.classList.toggle("pt-active", on); p.hidden = !on; });
      if (setHash !== false) { try { history.replaceState(null, "", "#" + slug); } catch (e) { /* leave the URL */ } }
      applySearch();
    }

    /* ---- accordion: one open at a time across all tabs ---- */
    function closeAll(except) {
      document.querySelectorAll(".pt-sp-row.pt-open").forEach(function (r) {
        if (r === except) return;
        r.classList.remove("pt-open");
        var b = r.querySelector(".pt-sp-qb"); if (b) b.setAttribute("aria-expanded", "false");
      });
    }
    function openRow(row, scroll) {
      if (!row) return;
      closeAll(row);
      row.classList.add("pt-open");
      var b = row.querySelector(".pt-sp-qb"); if (b) b.setAttribute("aria-expanded", "true");
      if (scroll) {
        var top = row.getBoundingClientRect().top + window.pageYOffset - HDR;
        try { window.scrollTo({ top: top, behavior: reduced ? "auto" : "smooth" }); } catch (e) { window.scrollTo(0, top); }
      }
    }
    document.querySelectorAll(".pt-sp-qb").forEach(function (btn) {
      if (btn.__ptBound) return; btn.__ptBound = true;
      btn.addEventListener("click", function () {
        var row = btn.closest(".pt-sp-row");
        if (row.classList.contains("pt-open")) { row.classList.remove("pt-open"); btn.setAttribute("aria-expanded", "false"); }
        else openRow(row, false);
      });
    });

    /* ---- tab clicks + arrow keys ---- */
    tabs.forEach(function (t, i) {
      t.addEventListener("click", function () {
        /* a tab tap while searching means "leave the search, show me that topic" */
        if (q && q.value) { q.value = ""; var hh = root.querySelector("#pt-sp-hint"); if (hh) hh.hidden = true; }
        activate(t.getAttribute("data-slug"));
      });
      t.addEventListener("keydown", function (e) {
        var d = e.key === "ArrowRight" ? 1 : e.key === "ArrowLeft" ? -1 : e.key === "Home" ? -i : e.key === "End" ? (tabs.length - 1 - i) : 0;
        if (!d) return;
        e.preventDefault();
        var n = tabs[(i + d + tabs.length) % tabs.length];
        activate(n.getAttribute("data-slug")); n.focus();
      });
    });

    /* ---- search: across ALL topics at once (owner 2026-08-23: "nothing
       here matches" while the answer sat one tab over was confusing).
       While a term is typed every panel shows, non-matching rows hide,
       panels with no hits hide, each panel with hits shows its heading as a
       small label with a count, and the tabs mute. Clearing the box returns
       to the active tab. ---- */
    /* ---- highlight: the typed term is wrapped in <mark> inside the question line and the
       answer of every matching row (owner 2026-08-23). Pristine markup is kept per row and
       restored before each pass so highlights never stack or survive a cleared box. ---- */
    function hlPristine(r) {
      if (!r.__ptHl) { var qn = r.querySelector(".pt-sp-q"), an = r.querySelector(".pt-sp-a"); r.__ptHl = { q: qn, qh: qn ? qn.innerHTML : "", a: an, ah: an ? an.innerHTML : "", on: false }; }
      return r.__ptHl;
    }
    function hlClear(r) {
      var p = r.__ptHl; if (!p || !p.on) return; p.on = false;
      if (p.q) p.q.innerHTML = p.qh;
      if (p.a) p.a.innerHTML = p.ah;
    }
    function hlIn(el, re) {
      if (!el) return;
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false), nodes = [];
      while (w.nextNode()) nodes.push(w.currentNode);
      nodes.forEach(function (t) {
        var s = t.nodeValue, frag = document.createDocumentFragment(), last = 0, m, any = false;
        re.lastIndex = 0;
        while ((m = re.exec(s))) {
          if (!m[0]) { re.lastIndex++; continue; }
          any = true;
          if (m.index > last) frag.appendChild(document.createTextNode(s.slice(last, m.index)));
          var mk = document.createElement("mark"); mk.className = "pt-sp-hl"; mk.textContent = m[0]; frag.appendChild(mk);
          last = m.index + m[0].length;
        }
        if (!any) return;
        if (last < s.length) frag.appendChild(document.createTextNode(s.slice(last)));
        t.parentNode.replaceChild(frag, t);
      });
    }
    function hlMark(r, re) {
      var p = hlPristine(r); p.on = true;
      hlIn(p.q, re); hlIn(p.a, re);
    }
    /* ---- matching (owner 2026-08-23, parity with the Kickstarter page): every meaningful word of
       the query must appear in the row's question, answer or hidden keywords (data-kw). Light
       stemming so "shipped" finds "ship" and "surveys" finds "survey"; filler words ignored. ---- */
    var STOP = /^(i|my|me|we|the|a|an|is|it|its|to|do|did|does|was|were|be|been|of|in|on|for|and|or|what|where|how|why|when|who|can|not|no|has|have|had|get|got|im|ive|am|are|you|your|this|that|with|at|from|still|never|didnt|havent|dont|cant|wasnt|isnt)$/;
    function stem(w) { w = w.replace(/ies$/, "y").replace(/(ing|ed|es|s)$/, ""); if (w.length > 3 && w[w.length - 1] === w[w.length - 2]) w = w.slice(0, -1); return w; }
    function words(str) {
      var raw = (str || "").toLowerCase().replace(/[\u2019']/g, "").replace(/[^a-z0-9]+/g, " ").trim();
      if (!raw) return [];
      var out = [], all = raw.split(" ");
      all.forEach(function (w) { if (w.length > 1 && !STOP.test(w)) out.push(stem(w)); });
      return out.length ? out : all.map(stem);
    }
    function rowText(r) {
      if (r.__ptTxt == null) r.__ptTxt = ((r.textContent || "") + " " + (r.getAttribute("data-kw") || "")).toLowerCase().replace(/[\u2019']/g, "");
      return r.__ptTxt;
    }
    var st;
    function applySearch() {
      var term = (q && q.value || "").trim().toLowerCase();
      var ws = words(term), re = null;
      if (ws.length) re = new RegExp("[a-z0-9\u2019']*(?:" + ws.map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); }).join("|") + ")[a-z0-9\u2019']*", "gi");
      var root2 = document.documentElement;
      var total = 0;
      panels.forEach(function (p) {
        var n = 0;
        p.querySelectorAll(".pt-sp-row").forEach(function (r) {
          var hit = true;
          if (ws.length) { var txt = rowText(r); for (var i = 0; i < ws.length; i++) { if (txt.indexOf(ws[i]) < 0) { hit = false; break; } } }
          r.hidden = term ? !hit : false;
          if (hit) n++;
          hlClear(r);
          if (term && hit && re) hlMark(r, re);
        });
        total += n;
        var ph = p.querySelector(".pt-sp-ph");
        if (term) {
          p.hidden = n === 0;
          if (ph) { ph.setAttribute("data-count", n); }
        } else {
          p.hidden = !p.classList.contains("pt-active");
        }
        var empty = p.querySelector(".pt-sp-empty"); if (empty) empty.hidden = true;
      });
      root2.classList.toggle("pt-sp-searching", !!term);
      root2.classList.toggle("pt-sp-noresults", !!term && total === 0);
      /* one shared empty state: the active panel's, shown when NOTHING matched anywhere */
      if (term && total === 0) {
        var act = panels.filter(function (p) { return p.classList.contains("pt-active"); })[0] || panels[0];
        if (act) {
          act.hidden = false;
          var e = act.querySelector(".pt-sp-empty");
          if (e) {
            e.hidden = false;
            var qt = e.querySelector(".pt-sp-qtxt"); if (qt) qt.textContent = (q.value || "").trim();
            var other = e.querySelector(".pt-sp-other"); if (other) other.hidden = true;
          }
        }
      }
    }
    /* ---- search → phone matcher hint: when the typed text looks like a
       phone, one quiet line under the search box offers the matcher on this
       page, prefilled with the same text (owner 2026-08-22) ---- */
    var hint = root.querySelector("#pt-sp-hint"), hintSeq = 0;
    function phoneHint() {
      if (!hint) return;
      var term = (q && q.value || "").trim();
      var seq = ++hintSeq;
      if (term.length < 2 || !window.ptMatchPhones || !window.ptOpenSheet) { hint.hidden = true; return; }
      window.ptMatchPhones(term, function (res) {
        if (seq !== hintSeq) return;                 /* typed on since; a newer call owns the line */
        var rows = (res && res.rows) || [];
        hint.innerHTML = "";
        var add = function (txt, fn) { var b = document.createElement("button"); b.type = "button"; b.textContent = txt; b.addEventListener("click", fn); hint.appendChild(b); };
        if (rows.length) {
          /* Best guess first, then the door to the rest (owner 2026-08-22: a
             match count is a vanity number). The guess is an exact alias hit
             ("galaxy s26" → Galaxy S26, not the higher-ranked S26 Ultra), else
             the top-ranked hit (database order: newest / most popular first). */
          var tl = term.toLowerCase(), best = rows.filter(function (r) { return (r.search || []).indexOf(tl) !== -1; })[0] || rows[0];
          if (cfg.hintLead) hint.appendChild(document.createTextNode(cfg.hintLead + " "));
          add(String(cfg.hintPhone || "Check the fit for {phone}").replace("{phone}", best.name), function () { if (window.ptPickPhone) window.ptPickPhone(best.id, "hint"); else window.ptOpenSheet(best.name); });
          if (cfg.hintOther) {
            hint.appendChild(document.createTextNode(" · "));
            add(cfg.hintOther, function () { window.ptOpenSheet(term); });
          }
          hint.hidden = false;
        } else if (res && res.family && cfg.hintGeneric) {
          if (cfg.hintLead) hint.appendChild(document.createTextNode(cfg.hintLead + " "));
          add(cfg.hintGeneric, function () { window.ptOpenSheet(term); });
          hint.hidden = false;
        } else hint.hidden = true;
      });
    }
    if (q && !q.__ptBound) {
      q.__ptBound = true;
      q.addEventListener("input", function () { clearTimeout(st); st = setTimeout(function () { applySearch(); phoneHint(); }, 80); });
      q.addEventListener("search", function () { applySearch(); phoneHint(); });
    }

    /* ---- task cards ---- */
    function findRow(want) {
      want = (want || "").trim().toLowerCase(); if (!want) return null;
      var rows = [].slice.call(document.querySelectorAll(".pt-sp-row"));
      return rows.filter(function (r) { return (r.getAttribute("data-q") || "").trim().toLowerCase() === want; })[0]
          || rows.filter(function (r) { return (r.getAttribute("data-q") || "").toLowerCase().indexOf(want) >= 0; })[0] || null;
    }
    root.querySelectorAll(".pt-sp-task[data-action]").forEach(function (card) {
      if (card.__ptBound) return; card.__ptBound = true;
      card.addEventListener("click", function () {
        if (card.getAttribute("data-action") === "matcher") {
          if (window.ptOpenSheet) window.ptOpenSheet();
          return;
        }
        var row = findRow(card.getAttribute("data-target"));
        if (!row) return;
        if (q) q.value = "";
        activate(row.closest(".pt-sp-panel").getAttribute("data-slug"));
        openRow(row, true);
      });
    });

    /* ---- "Find my fit" links inside answers: rich-text settings allow only a
       plain href, so the hook is the hash itself ---- */
    if (!document.__ptSpFitLinks) {
      document.__ptSpFitLinks = true;
      document.addEventListener("click", function (e) {
        var a = e.target.closest && e.target.closest('.pt-sp a[href="#find-my-fit"]');
        if (!a) return;
        e.preventDefault();
        if (window.ptOpenSheet) window.ptOpenSheet();
      });
    }

    /* ---- phone matcher result, shown in place (no detour to the product) ---- */
    var box = root.querySelector("#pt-sp-match");
    /* The product page resolves ?model= through the same database and lands
       with that phone and fit already chosen (and &case= answers the case
       question for the phones that ask one), so the shop link hands over
       exactly what was matched here rather than starting the shopper over. */
    function shopUrl(base, m) {
      if (!m || !m.id) return base;
      var hash = "", u = String(base), i = u.indexOf("#");
      if (i >= 0) { hash = u.slice(i); u = u.slice(0, i); }
      u += (u.indexOf("?") >= 0 ? "&" : "?") + "model=" + encodeURIComponent(m.id);
      if (m.caseAnswer === "case" || m.caseAnswer === "no_case") u += "&case=" + m.caseAnswer;
      return u + hash;
    }
    function renderMatch() {
      if (!box || !match) return;
      var fitLabel = match.fit === "slim" ? (cfg.fitSlim || "Slim Fit") : (cfg.fitStd || "Standard Fit");
      var note = match.fit === "slim" ? (cfg.fitSlimRange || "") : (cfg.fitStdRange || "");
      box.innerHTML = "";
      /* three calm lines (owner 2026-08-22: one run-on line was crowded on
         a phone): who matched · the fit stamp + range · the two actions */
      var l1 = document.createElement("div"); l1.className = "pt-sp-ml1";
      var lead = document.createElement("span"); lead.className = "pt-sp-mlead"; lead.textContent = (cfg.matchLead || "Your match:") + " ";
      var ph = document.createElement("strong"); ph.textContent = match.phone;
      l1.appendChild(lead); l1.appendChild(ph); box.appendChild(l1);
      var l2 = document.createElement("div"); l2.className = "pt-sp-ml2";
      var fit = document.createElement("span"); fit.className = "pt-sp-mfit"; fit.textContent = fitLabel;
      l2.appendChild(fit);
      if (note) { var nt = document.createElement("span"); nt.className = "pt-sp-mnote"; nt.textContent = note; l2.appendChild(nt); }
      box.appendChild(l2);
      var acts = document.createElement("div"); acts.className = "pt-sp-macts";
      var chg = document.createElement("button"); chg.type = "button"; chg.textContent = cfg.matchChange || "Change phone";
      chg.addEventListener("click", function () { if (window.ptOpenSheet) window.ptOpenSheet(); });
      acts.appendChild(chg);
      if (cfg.productUrl && cfg.matchShop) {
        var shop = document.createElement("a"); shop.className = "pt-sp-shop pt-glow"; shop.href = shopUrl(cfg.productUrl, match); shop.textContent = String(cfg.matchShop).replace("{fit}", fitLabel);
        acts.appendChild(shop);
      }
      box.appendChild(acts);
      box.hidden = false;
      /* restart the arrival motion on every (re)match; the link is a fresh
         node so its glow runs on its own */
      box.classList.remove("pt-in"); void box.offsetWidth; box.classList.add("pt-in");
    }
    if (!document.__ptSpMatchBound) {
      document.__ptSpMatchBound = true;
      document.addEventListener("pt:fit-match", function (e) {
        var d = e.detail || {};
        if (!d.phone) return;
        match = { phone: d.phone, id: d.id || null, caseAnswer: d.caseAnswer || null, fit: d.fit === "slim" ? "slim" : (d.fit === "standard" ? "standard" : d.fit) };
        if (match.fit !== "slim" && match.fit !== "standard") return;   /* "contact" / "ask" paths show nothing */
        renderMatch();
        var hh = document.getElementById("pt-sp-hint"); if (hh) hh.hidden = true;
        var b = document.getElementById("pt-sp-match");
        if (b) { try { b.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "center" }); } catch (e2) {} }
      });
    }
    renderMatch();

    /* ---- initial state: URL hash = tab slug or answer id ---- */
    var h = (location.hash || "").replace(/^#/, "");
    if (h && slugs.indexOf(h) >= 0) activate(h, false);
    else if (h && /^pt-sq-/.test(h) && document.getElementById(h)) {
      var r0 = document.getElementById(h);
      activate(r0.closest(".pt-sp-panel").getAttribute("data-slug"), false);
      openRow(r0, true);
    } else activate((root.getAttribute("data-default") || "") && slugs.indexOf(root.getAttribute("data-default")) >= 0 ? root.getAttribute("data-default") : slugs[0], false);
    if (!booted) {
      booted = true;
      window.addEventListener("hashchange", function () {
        var hh = (location.hash || "").replace(/^#/, "");
        if (slugs.indexOf(hh) >= 0) activate(hh, false);
      });
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  /* Theme Editor: any support-related section reload re-assembles the page */
  document.addEventListener("shopify:section:load", function () { setTimeout(init, 0); });
  document.addEventListener("shopify:section:reorder", function () { setTimeout(init, 0); });
})();
